// @flow

import React from 'react'
import PropTypes from 'prop-types'
import glamorous from 'glamorous'
import { css } from 'glamor'
import getContent from 'pp-react-l10n'
import { Link } from '@paypalcorp/pp-react'
import LocalizedImg from './localized-img'

const PageContainer = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
})

const ImgContainer = glamorous.div({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  minWidth: '34rem',
  minHeight: '19.375rem',

  '@media (max-width: 768px)': {
    minWidth: '22rem',
  },
})

const Img = glamorous.img({
  position: 'relative',
  zIndex: 1,
  '@media (max-width: 768px)': {
    minWidth: '80%',
  },
})

const Header = glamorous.div({
  marginTop: '2.25rem',
  fontSize: '1.75rem',
  fontWeight: '400',
  textAlign: 'center',
  height: 64,
  '@media (max-width: 768px)': {
    maxWidth: '20rem',
    fontSize: '1.5rem',
  },
  '@media(max-width: 425px)': {
    maxWidth: '18rem',
  },
})

const SubHeader = glamorous.p({
  marginTop: '2.25rem',
  fontSize: '0.875rem',
  textAlign: 'center',
  width: '19rem',
  minHeight: '3.125rem',
})

const SubheaderLinks = css({
  fontSize: '0.875rem',
})

const l10n = getContent('pages/seller/landing')

const pageObjects = [
  {
    image: '',
    header: 'page1.header',
    subheader: '',
  },
  {
    image:
      'https://www.paypalobjects.com/p2p_seller_profiles/seller_landing_page2.png',
    header: 'page2.header',
    subheader: l10n('page2.subheader', {
      buyer: (
        <Link
          href="https://www.paypal.com/us/webapps/mpp/paypal-safety-and-security"
          target="_blank"
          className={`${SubheaderLinks}`}
        >
          {l10n('page2.buyer')}
        </Link>
      ),
      seller: (
        <Link
          href="https://www.paypal.com/us/webapps/mpp/security/seller-protection"
          target="_blank"
          className={`${SubheaderLinks}`}
        >
          {l10n('page2.seller')}
        </Link>
      ),
    }),
  },
  {
    image:
      'https://www.paypalobjects.com/p2p_seller_profiles/seller_landing_page3.png',
    header: 'page3.header',
    subheader: (
      <Link
        href="https://www.paypal.com/us/webapps/mpp/merchant-fees#fixed-fees-commercialtrans"
        target="_blank"
        className={`${SubheaderLinks}`}
      >
        {l10n('page3.subheader')}
      </Link>
    ),
  },
]

PageSwitcher.defaultProps = {
  currentPage: 0,
}

PageSwitcher.propTypes = {
  currentPage: PropTypes.number.isRequired,
}

function PageSwitcher(props) {
  const { currentPage } = props

  return (
    <PageContainer>
      <ImgContainer>
        {currentPage === 0 ? (
          <LocalizedImg />
        ) : (
          <Img
            src={pageObjects[currentPage].image}
            alt={`page ${currentPage}`}
          />
        )}
      </ImgContainer>
      <Header>{l10n(`${pageObjects[currentPage].header}`)}</Header>
      <SubHeader>{pageObjects[currentPage].subheader}</SubHeader>
    </PageContainer>
  )
}

export default PageSwitcher
